import { useLocation } from 'react-router-dom';

/* The Smart Building Dashboard is our own app rather than somewhere else
   on the web. It opens in this tab, and its close control returns the
   reader to the page they left, which it can only do if we tell it where
   that was. Nothing else can: a cross-origin referrer is trimmed to the
   bare origin, and a link opened in a new tab has no history to go back
   to at all.
 *
 * The dashboard checks the address it is handed against its own list of
 * our sites before offering it, so a hand-edited one goes nowhere. */
export default function useCompanionHref(item) {
    const { pathname } = useLocation();

    if (!item.companion) return item.href;

    const separator = item.href.includes('?') ? '&' : '?';
    const here = typeof window === 'undefined'
        ? pathname
        : `${window.location.origin}${pathname}`;

    return `${item.href}${separator}from=${encodeURIComponent(here)}`;
}
